"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const complexData_1 = __importDefault(require("@powerednow/complexData/complexData"));
const entity_1 = __importDefault(require("./entity"));
const modelProperties_1 = __importDefault(require("./modelProperties"));
const modelLookup_1 = require("../modelLookup");
// eslint-disable-next-line no-redeclare
class PaymentTypeToCountry extends complexData_1.default {
    static get allowedAssociations() {
        return {
            paymentType: {
                key: 'paymentType',
                instance: (0, modelLookup_1.complexFindModel)('PaymentType'),
                single: true,
                cascadeDelete: false,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().paymenttype_id,
                },
            },
            country: {
                key: 'country',
                instance: (0, modelLookup_1.complexFindModel)('Country'),
                single: true,
                cascadeDelete: false,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().country_id,
                },
            },
        };
    }
}
PaymentTypeToCountry.Entity = entity_1.default;
PaymentTypeToCountry.modelProperties = modelProperties_1.default;
exports.default = PaymentTypeToCountry;
//# sourceMappingURL=../../../../src/models/paymentTypeToCountry/index.js.map